import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
    ColumnDirective, ColumnsDirective,
    GridComponent, Grid, Inject, Page, Sort, Filter, Resize,
    Toolbar, ExcelExport, PdfExport, ColumnChooser
} from '@syncfusion/ej2-react-grids';
import { getValue } from '@syncfusion/ej2-base';
import { AggregatesDirective, Aggregate, AggregateColumnsDirective, AggregateDirective, AggregateColumnDirective }
    from '@syncfusion/ej2-react-grids';
import HttpClient from './../../../services/httpClient';
import SemanticDatepicker from 'react-semantic-ui-datepickers';
import { Dropdown, Select } from 'semantic-ui-react'
import { Button } from 'semantic-ui-react'
import 'react-semantic-ui-datepickers/dist/react-semantic-ui-datepickers.css';
import { useTranslation } from "react-i18next";
import { finishLoading, setTitle, startLoading } from "./../../../store/actions/uiAction";
import { logReportService } from "./../../../services/logReportService";
import ComboHotelSala from "./../../../components/combo-hotel-sala/combo-hotel-sala";
import { MultiSelectComponent, CheckBoxSelection } from '@syncfusion/ej2-react-dropdowns';

const ManifestReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [dateStart, setDateStart] = useState(new Date());
    const [dateEnd, setDateEnd] = useState(new Date());
    const [rowData, setRowData] = useState([]);
    const [NameSala, setNameSala] = useState([]);
    const [NameHotel, setNameHotel] = useState([]);
    const [programasData, setProgramasData] = useState([]);
    const [NamePrograma, setNamePrograma] = useState([]);
    const user = useSelector(state => state.auth.currentUser);
    const { idSaleRoom, idHotel } = useSelector(state => state.user.param);
    let grid = null;
    let mulObjProgramas = null;
    let excelFrozenRows = 0;

    const toolbarOptions = ['ExcelExport', 'ColumnChooser'];
    const checkFields = { text: 'Name', value: 'Code' };

    const options = [
        { key: 'excel', icon: 'edit', text: 'Export to excel', value: 'excel' },
        { key: 'pdf', icon: 'delete', text: 'Export to pdf', value: 'pdf' },
    ]

    const onChangeDateStart = (event, data) => setDateStart(data.value);
    const onChangeDateEnd = (event, data) => setDateEnd(data.value);

    const getData = (url, data) => {
        dispatch(startLoading());
        return new Promise((resolve, reject) => {
            HttpClient.get(url, data)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    reject(error);
                })
        });
    }

    const getOptionData = (url) => {
        return new Promise((resolve, reject) => {
            getData(url).then((response) => {
                if (response.status === 200) {
                    let obj = response.data;
                    let res = [];
                    for (let i in obj) {
                        let item = { Code: obj[i].id, Name: obj[i].name };
                        res.push(item)
                    }
                    resolve(res);
                }
            })
        })
    }

    const getProgramasData = () => {
        getOptionData('/catalog/programas')
            .then((response) => {
                setProgramasData(response);
            })
    }

    const getDataReport = (url) => {
        dispatch(startLoading());
        return new Promise((resolve, eject) => {
            HttpClient.get(url)
                .then(response => {
                    dispatch(finishLoading());
                    resolve(response);
                })
                .catch(error => {
                    dispatch(finishLoading());
                    eject(error);
                })
        });
    }

    const handleViewButton = () => {
        getManifestReport();
    }

    const exportExcelFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        var download_excel_url = `${base_url}/reports/manifest-export-xls/${date1}/${date2}/${idSaleRoom}/${idHotel}/${programas}`;
        //console.log(download_excel_url);
        window.open(download_excel_url, '_parent');
    }


    const exportExcelTotalFromAPI = () => {
        const base_url = process.env.REACT_APP_URL_API_PATH;
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';
        var download_excel_url = `${base_url}/reports/manifest-export-all-xls/${date1}/${date2}/${idSaleRoom}/${idHotel}/${programas}`;
        //console.log(download_excel_url);
        window.open(download_excel_url, '_parent');
    }

    const getManifestReport = () => {
        const date1 = dateStart.toISOString().slice(0, 10).replace(/-/g, '');
        const date2 = dateEnd.toISOString().slice(0, 10).replace(/-/g, '');
        const programas = (mulObjProgramas?.value?.length > 0)
            ? mulObjProgramas.value.map(String).toString()
            : '0';

        getDataReport(`/catalog/getNameSalavtaId/${idSaleRoom}`).then((response) => {
            if (response.status === 200) {
                setNameSala(response.data);
            }
        })

        getDataReport(`/catalog/getNameHotelId/${idHotel}`).then((response) => {
            if (response.status === 200) {
                setNameHotel(response.data);
            }
        })

        
        getDataReport(`/catalog/getNameProgramaId/${programas}`).then((response) => {
            if (response.status === 200) {
                console.log(response.data);
                
                setNamePrograma(response.data);
            }
        })


        getDataReport(`/reports/manifest/${date1}/${date2}/${idSaleRoom}/${idHotel}/${programas}`).then((response) => {
            if (response.status === 200) {
                setRowData(response.data);
                logReportService.add('Manifest Report', user);
            }
        })
    }

    // Reporte
    const handleButtonOption = (opt) => {
        if (grid && opt.target.innerText === 'Export to excel') {
            //export2Excel();
            exportExcelFromAPI();
        } else {
            if (grid && opt.target.innerText === 'Export to pdf') {
                grid.pdfExport();
            }
        }
    }

    const getCalifTotals = () => {
        const totals = { Q: 0, Q1: 0, QF: 0, NQ: 0, NQF: 0, NQE: 0, CT: 0 };
        if (!rowData || !Array.isArray(rowData)) return totals;
        
        rowData.forEach(row => {
            if (!row) return;

            const rowColor = String(row.color ?? '').trim().toLowerCase();
            if (rowColor !== 'verde' && rowColor !== 'green' && rowColor !== 'blanco' && rowColor !== 'white') return;

            const calif = String(row.calif ?? '').trim().toUpperCase();
            if (calif === 'Q') totals.Q++;
            else if (calif === 'Q1') totals.Q1++;
            else if (calif === 'QF') totals.QF++;
            else if (calif === 'NQ') totals.NQ++;
            else if (calif === 'NQF') totals.NQF++;
            else if (calif === 'NQE') totals.NQE++;
            else if (calif === 'CT') totals.CT++;
        });
        return totals;
    };

    const getExportTotals = () => {
        const totals = {
            inOut: 0,
            dslCount: 0,
            salesCount: 0,
            salesPrice: 0,
            oopCount: 0,
            oopSalesPrice: 0,
            pendingCount: 0,
            pendingSalesPrice: 0,
            totalVolume: 0,
            totalClosing: 0,
            dslVolume: 0,
            avgVentas: 0
        };

        if (!rowData || !Array.isArray(rowData)) return totals;

        const toNumber = (value) => {
            if (value === null || value === undefined || value === '') return 0;
            if (typeof value === 'number') return Number.isFinite(value) ? value : 0;
            const parsed = Number(String(value).replace(/,/g, ''));
            return Number.isFinite(parsed) ? parsed : 0;
        };

        let companyCount = 0;

        rowData.forEach((row) => {
            if (!row) return;

            totals.inOut += toNumber(row.inout);
            totals.salesCount += toNumber(row.processable);
            totals.salesPrice += toNumber(row.salespriceproc);
            totals.oopCount += toNumber(row.oop);
            totals.oopSalesPrice += toNumber(row.salespriceoop);
            totals.pendingCount += toNumber(row.pending);
            totals.pendingSalesPrice += toNumber(row.salespricepend);
            totals.totalClosing += toNumber(row.closingc);

            if (row.empresa) {
                companyCount += 1;
            }

            if (row.empresa === 'DSL') {
                totals.dslCount += 1;
                totals.dslVolume += toNumber(row.salespriceproc);
            }
        });

        totals.totalVolume = totals.salesPrice + totals.oopSalesPrice;
        totals.avgVentas = companyCount > 0 ? Number(((totals.dslCount * 100) / companyCount).toFixed(2)) : 0;

        return totals;
    };

    const export2Excel = () => {

        const date1 = dateStart.toDateString();
        const date2 = dateEnd.toDateString();
        const califTotals = getCalifTotals();
        const exportTotals = getExportTotals();

        const labelCellStyle = { fontColor: '#000000', backColor: '#8fc6e0', fontSize: 12, hAlign: 'Left', bold: true };
        const valueCellStyle = { fontColor: '#000000', fontSize: 12, hAlign: 'Right', bold: false };
        const currencyValueCellStyle = { ...valueCellStyle, numberFormat: '$#,##0.00' };

        const formatCurrency = (value) => Number((value || 0).toFixed(2));

        const headerRows = [
            { cells: [{ colSpan: 8, value: "LVC KCS " + t('menusidebar.label.manifest-report'), style: { fontColor: '#000000', fontSize: 16, hAlign: 'Left', bold: true } }] },
            { cells: [{ colSpan: 8, value: "SALES ROOM: " + (NameSala["name"] || ""), style: { fontColor: '#000000', fontSize: 14, hAlign: 'Left', bold: true } }] },
            { cells: [{ colSpan: 8, value: "HOTELS: " + (NameHotel["name"] || ""), style: { fontColor: '#000000', fontSize: 14, hAlign: 'Left', bold: true } }] },
            { cells: [{ colSpan: 4, value: "PROGRAMS: " + (NamePrograma[0]?.["name"] || ""), style: { fontColor: '#000000', fontSize: 13, hAlign: 'Left', bold: true, } }] },
            { cells: [{ colSpan: 8, value: date1 + " - " + date2, style: { fontColor: '#000000', fontSize: 14, hAlign: 'Left', bold: true } }] },
                    
            { cells: [{ value: "", colSpan: 8 }] },
            {
                cells: [
                    { value: "TOTAL Qs:", style: labelCellStyle },
                    { value: califTotals.Q ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "DSL", style: labelCellStyle },
                    { value: exportTotals.dslCount ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "TOTAL SALES", style: labelCellStyle },
                    { value: exportTotals.salesCount ?? 0, style: valueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL Q1s:", style: labelCellStyle },
                    { value: califTotals.Q1 ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "% VENTAS", style: labelCellStyle },
                    { value: (exportTotals.avgVentas ?? 0) + "%", style: valueCellStyle },
                    { value: "" },
                    { value: "SALES PRICE", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.salesPrice), style: currencyValueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL QFs:", style: labelCellStyle },
                    { value: califTotals.QF ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "VOLUMEN", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.dslVolume), style: currencyValueCellStyle },
                    { value: "" },
                    { value: "OOP", style: labelCellStyle },
                    { value: exportTotals.oopCount ?? 0, style: valueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL NQs:", style: labelCellStyle },
                    { value: califTotals.NQ ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "SALES PRICE OOP", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.oopSalesPrice), style: currencyValueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL NQFs:", style: labelCellStyle },
                    { value: califTotals.NQF ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "PENDING", style: labelCellStyle },
                    { value: exportTotals.pendingCount ?? 0, style: valueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL NQEs:", style: labelCellStyle },
                    { value: califTotals.NQE ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "SALES PRICE PENDING", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.pendingSalesPrice), style: currencyValueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "TOTAL CT:", style: labelCellStyle },
                    { value: califTotals.CT ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "TOTAL VOLUMEN", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.totalVolume), style: currencyValueCellStyle }
                ]
            },
            {
                cells: [
                    { value: "IN OUT:", style: labelCellStyle },
                    { value: exportTotals.inOut ?? 0, style: valueCellStyle },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "" },
                    { value: "TOTAL CC", style: labelCellStyle },
                    { value: formatCurrency(exportTotals.totalClosing), style: currencyValueCellStyle }
                ]
            },
            { cells: [{ value: "", colSpan: 8 }] }
        ];

        // Cantidad de filas a congelar: bloque de totales + encabezado del grid.
        excelFrozenRows = headerRows.length + 1;

        const excelExportProperties = {
            fileName: t('menusidebar.label.manifest-report') + ".xlsx",
            theme: {
                caption: { fontName: 'Calibri', fontColor: '#666666', fontSize: 13 },
                header: { fontName: 'Calibri', fontColor: '#000000', backColor: '#3F97BF', fontSize: 13 },
            },
            header: {
                headerRows: headerRows.length,
                rows: headerRows
            },
            dataSource: rowData,
            includeHiddenColumn: false,
            hierarchyExportMode: 'All'
        }
        
        grid.excelExport(excelExportProperties);
    }

    const handleExport2Excel = () => {
        if (grid) {
            export2Excel();
        }
    }

    const handleToolbarClick = (args) => {
        if (grid && args.item.id === 'grid_excelexport') {
            export2Excel();
        } else {
            if (grid && args.item.id === 'grid_pdfexport') {
                grid.pdfExport();
            }
        }
    }

    const pageOptions = {
        pageSize: 50, pageSizes: true
    };

    const getRowBackgroundColor = (data) => {
        const rowColor = String(getValue('color', data) || '').trim().toLowerCase();
        if (!rowColor) return '';

        const colorMap = {
            verde: '#d4edda',
            green: '#d4edda',
            gris: '#e9ecef',
            gray: '#e9ecef',
            grey: '#e9ecef',
            blanco: '#ffffff',
            white: '#ffffff'
        };

        if (colorMap[rowColor]) {
            return colorMap[rowColor];
        }

        const isHexColor = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(rowColor);
        const isRgbColor = /^rgba?\(/i.test(rowColor);
        return (isHexColor || isRgbColor) ? rowColor : '';
    };


    const dataBound = () => {
        if (grid) {
            grid.autoFitColumns();
        }
    }

    function footerSum(props) {
        return (<span>{props.Sum || props.Custom || 0}</span>);
    }

    function customAggregateFnSumCalifQ(data) {
        if (!data || !data.result || !Array.isArray(data.result)) {
            return "Q:0";
        }
        var gridData = data.result;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i] && gridData[i]['oop'] == '0') {
                gridData[i]['calif'] == 'Q' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "Q:" + totalSum1;
    }



    function customAggregateFnSumCalifNQ(data) {
        if (!data || !data.result || !Array.isArray(data.result)) {
            return "NQ:0";
        }
        var gridData = data.result;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i] && gridData[i]['oop'] == '0') {
                gridData[i]['calif'] == 'NQ' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "NQ:" + totalSum1;
    }

    function customAggregateFnSumCalifCT(data) {
        if (!data || !data.result || !Array.isArray(data.result)) {
            return "CT:0";
        }
        var gridData = data.result;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i] && gridData[i]['oop'] == '0') {
                gridData[i]['calif'] == 'CT' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "CT:" + totalSum1;
    }


    function customAggregateFnSumCalifInout(data) {
        if (!data || !data.result || !Array.isArray(data.result)) {
            return "IN & OUT:0";
        }
        var gridData = data.result;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i] && gridData[i]['oop'] == '0') {
                gridData[i]['calif'] == 'IN & OUT' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "IN & OUT:" + totalSum1;
    }

    function customAggregateFnSumvtaDSL() {
        if (!grid || !grid.dataSource) return "DSL:0";
        var gridData = grid.dataSource;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i]) {
                gridData[i]['empresa'] == 'DSL' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "DSL:" + totalSum1;
    }


    function customAggregateFnSumVtaTDVC(data) {
        if (!data || !data.result || !Array.isArray(data.result)) {
            return "TDVC:0";
        }
        var gridData = data.result;
        var totalSum1 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i]) {
                gridData[i]['empresa'] == 'TDVC' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }
        return "TDVC:" + totalSum1;
    }

    function customAggregateFnAvgDSL() {
        if (!grid || !grid.dataSource) return "% VENTAS:0%";
        var gridData = grid.dataSource;
        var totalSum1 = 0;
        var totalSum2 = 0;
        
        for (var i = 0; i < gridData.length; i++) {
            if (gridData[i]) {
                totalSum2 = gridData[i]['empresa'] ? totalSum2 = totalSum2 + 1 : totalSum2 = totalSum2;
                gridData[i]['empresa'] == 'DSL' ? totalSum1 = totalSum1 + 1 : totalSum1 = totalSum1;
            }
        }

        let avg = 0;
        totalSum2 == 0 ? avg = 0 : avg = totalSum1 * 100 / totalSum2;
        avg = Number((avg).toFixed(1));
        
        return "% VENTAS:" + avg + "%";
    }







    // Fin Reporte

    useEffect(() => {
        getProgramasData();
        dispatch(setTitle(t('menusidebar.label.manifest-report')));
    }, []);

    const rowDataBound = (args) => {
        if (!args.row) return;

        const rowBackgroundColor = getRowBackgroundColor(args.data);

        // New API field: reports/manifest now returns "color" to paint each row.
        if (rowBackgroundColor) {
            args.row.style.backgroundColor = rowBackgroundColor;
            return;
        }

        // Backward compatibility when API still does not provide "color".
        if (getValue('oop', args.data) == '1') {
            args.row.classList.add('below-80');
        }
        else if (getValue('opp', args.data) == 0) {
            args.row.classList.add('below-30');
        }
        else {
            args.row.classList.add('above-80');
        }
    };

    const excelQueryCellInfo = (args) => {
        const rowBackgroundColor = getRowBackgroundColor(args && args.data);
        if (!rowBackgroundColor) return;

        args.style = {
            ...(args.style || {}),
            backColor: rowBackgroundColor
        };
    };

    const beforeExcelExport = (args) => {
        // Syncfusion aplica paneles inmovilizados desde sheet.freeze (no desde excelExportProperties.frozenRows).
        const freezeRows = excelFrozenRows > 0 ? excelFrozenRows : 1;
        if (args && args.gridObject && args.gridObject.excelExportModule && args.gridObject.excelExportModule.sheet) {
            args.gridObject.excelExportModule.sheet.freeze = { row: freezeRows, column: 0 };
        }
    };

    const excelExportComplete = (args) => {
        // Los agregados se han exportado correctamente con los totales
    };



    return (
        <div className="container-fluid">
            <ComboHotelSala />
            <div className="row col-md-12">
                <div className="col-md-6 form-group">
                    <label>Programas:</label>
                    <MultiSelectComponent
                        id="programas"
                        ref={(scope) => { mulObjProgramas = scope; }}
                        dataSource={programasData}
                        fields={checkFields}
                        placeholder="Seleccionar programas"
                        mode="CheckBox"
                        showSelectAll={true}
                        value={[]}
                        showDropDownIcon={true}
                        filterBarPlaceholder="Buscar programa"
                        popupHeight="350px"
                    >
                        <Inject services={[CheckBoxSelection]} />
                    </MultiSelectComponent>
                </div>
            </div>
            <div className="row col-md-12">
                <div className="col-md-3 form-group">
                    <label >Date start:</label>
                    <SemanticDatepicker className="col-md-12" name="dateStart" value={dateStart} onChange={onChangeDateStart} />

                </div>
                <div className="col-md-3  form-group ">

                    <label >Date end:</label>
                    <SemanticDatepicker className="col-md-12" name="dateEnd" value={dateEnd} onChange={onChangeDateEnd} />

                </div>
                <div className="col-md-6  form-group">
                    <Button primary onClick={handleViewButton}>View Report</Button>
                    <Button positive onClick={exportExcelFromAPI}>Export Report By Hotel</Button>
                    {/*<Button positive onClick={exportExcelTotalFromAPI}>Export Report All</Button>*/}
                    {/*<Button.Group className="col-md-3" color='orange'>
                        <Button onClick={handleExport2Excel}>Print Report</Button>
                        <Dropdown
                            className='button icon'
                            floating
                            options={options}
                            onChange={handleButtonOption}
                            trigger={<></>}
                        />
                        </Button.Group>*/}


                </div>
            </div>
            <div style={{ border: '1px solid #dee2e6', borderRadius: '4px', overflow: 'hidden' }}>
              
                <GridComponent id="grid" height='100%' width='auto'
                    dataSource={rowData}
                    allowSorting={true}
                    allowResizing={true}
                    allowExcelExport={true}
                    allowPdfExport={false}
                    toolbar={toolbarOptions}
                    showColumnChooser={true}
                    toolbarClick={handleToolbarClick}
                    beforeExcelExport={beforeExcelExport}
                    excelExportComplete={excelExportComplete}
                    excelQueryCellInfo={excelQueryCellInfo}
                    dataBound={dataBound}
                    rowDataBound={rowDataBound}
                    allowPaging={true}
                    pageSettings={pageOptions}
                    ref={g => grid = g}

                >
                    <Inject services={[Sort, Toolbar, Resize, ExcelExport, PdfExport, Aggregate, Page, ColumnChooser]} />
                    <ColumnsDirective>
                        <ColumnDirective field='rownum' headerText="Num" minWidth='5' textAlign="Left" />
                        <ColumnDirective field='lead' headerText="Lead" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='reservid' headerText="Reserv. ID" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='lastname' headerText="LastName" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='firstname' headerText="FirstName" minWidth='20' textAlign="Left" />
                        <ColumnDirective field='age' headerText="Age" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='mstatus' headerText="M.status" minWidth='10' textAlign="Right" />
                        <ColumnDirective field='occupation' headerText="Occupation" minWidth='10' textAlign="Right" />
                        <ColumnDirective field='country' headerText="Country" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='agency' headerText="Agency" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='hotel' headerText="Hotel" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='room' headerText="Room" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pax' headerText="Pax" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='chkin' headerText="Chk-In" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='chkout' headerText="Chk-Out" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='showd' headerText="Show D." minWidth='10' textAlign="Left" />
                        <ColumnDirective field='in' headerText="In" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='out' headerText="Out" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='calif' headerText="Calif" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='califsale' headerText="Calif Sale" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='inout' headerText="IN OUT" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='wo' headerText="WO" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr1noemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr1' headerText="Concierge 1" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr2noemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='pr2' headerText="Concierge 2" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='linernoemploye' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='liner' headerText="Liner" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftmnoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftm' headerText="FTM" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftbnoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='ftb' headerText="FTB" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='closernoemployee' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='closer' headerText="Closer" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='exitclosernoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='exitcloser' headerText="Exit Closer" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='vlonoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='vlo' headerText="VLO" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='hostnoemp' headerText="# Emp" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='host' headerText="Host" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='empresa' headerText="Empresa" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='processable' headerText="Processable" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='salespriceproc' headerText="Sales Price" minWidth='10' textAlign="Left" format="C2" />
                        <ColumnDirective field='oop' headerText="OOP" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='salespriceoop' headerText="Sales Price OOP" minWidth='10' textAlign="Left" format="C2" />
                        <ColumnDirective field='pending' headerText="Pending" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='salespricepend' headerText="Sales Price" minWidth='10' textAlign="Left" format="C2" />
                        <ColumnDirective field='fechaVta' headerText="Sale date" Width='10' textAlign="center" />
                        <ColumnDirective field='fechaProceso' headerText="Proc date" minWidth='10' textAlign="center" />
                        <ColumnDirective field='membership' headerText="Membership" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='typesale' headerText="Tipo Venta" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='statuscto' headerText="Estatus" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='unittype' headerText="Unit Type" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='membtype' headerText="Memb. Type" minWidth='10' textAlign="Left" />
                        <ColumnDirective field='closingc' headerText="Closing C." minWidth='10' textAlign="Left" format="C2" />
                        <ColumnDirective field='tipoinvitacion' headerText="Invitation type" minWidth='10' textAlign="Left" />

                        <ColumnDirective field='comments' headerText="Comments" minWidth='10' textAlign="Left" />
                    </ColumnsDirective>
                  
                </GridComponent>
            </div>
        </div>
    );
}

export default ManifestReport;
